import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages/ai-config-items';

import { FindActionItemsIcon } from '../../../../icons/prompt/findActionItems';
import {
	createInsertAtCurrentPosition,
	createInsertAtTop,
	createInsertBelow,
} from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type {
	EditorPluginAIConfigItemWithOptionsFactory,
	EditorPluginAIConfigItemFactory,
} from '../../config-items';

export const findActionItems: EditorPluginAIConfigItemFactory = (options) => ({
	key: CONFIG_ITEM_KEYS.FIND_ACTION_ITEMS,
	title: aiConfigItemMessages.findActionItemsTitle,
	description: aiConfigItemMessages.findActionItemsDescription,
	icon: () => <FindActionItemsIcon />,
	intentSchemaId: 'action_items_intent_schema.json',
	featureId: 'find_action_items',
	actions: {
		empty: [
			createInsertAtTop({ appearance: 'secondary' }),
			createInsertAtCurrentPosition({ appearance: 'primary' }),
		],
		selection: [
			createInsertAtTop({ appearance: 'secondary' }),
			createInsertBelow({ appearance: 'primary', factoryOptions: options }),
		],
	},
	getBackendModel: () => {
		return 'assistance-service';
	},
});

export const findActionItemsWithOptions: EditorPluginAIConfigItemWithOptionsFactory = (
	options,
) => ({
	config: findActionItems(options),
	triggers: { empty: { enabled: true, docMinSize: 1 }, selection: { enabled: true } },
});
